import { t } from 'i18next';

export const errors = {
  invalidLastDigits: 'invalid_last_digits',
  duplicatedDigits: 'pin_has_duplicated_digits',
};

export const getError = (status: string) => {
  if (status === errors.duplicatedDigits) {
    return {
      title: t('activate_card.errors.pin_has_duplicated_digits.title'),
      description: t(
        'activate_card.errors.pin_has_duplicated_digits.description'
      ),
    };
  }
  if (status === errors.invalidLastDigits) {
    return {
      title: t('activate_card.errors.invalid_last_digits.title'),
      description: t('activate_card.errors.invalid_last_digits.description'),
    };
  }
  return {
    title: t('activate_card.error.title'),
    description: t('activate_card.error.description'),
  };
};
